import { gql } from '__generated__';

export default gql(`
  mutation DeleteMessage($id: ID!) {
    deleteMessage(id: $id)
  }
`);
